import store from '../store';
import { signOutSuccess } from '../store/auth/sessionSlice';

export const API_URL = process.env.REACT_APP_API_URL;
export const PERSIST_STORE_NAME = 'admin';
const unauthorizedCode = [401];

export const transformErrorResponse = (response) => {
  if (
    response &&
    unauthorizedCode.includes(response.status)
  ) {
    store.dispatch(signOutSuccess());
  }

  if (response && response.status === 404) {
    window.location.href = '/404';
  }

  // - response.error will have the actual error data
  // - response.error.data will also work for legacy code
  const errorData = response?.data || response;

  return {
    ...errorData,
    data: errorData  // Backward compatibility
  };
};

// For endpoints whose 404 belongs in a toast on the calling page, not a
// hard redirect of the whole SPA (e.g. deleting a row that is already gone).
// Preserves the status the shared transform drops. Signs nobody out and
// navigates nowhere; the caller decides what the error means.
export const inlineErrorResponse = (response) => {
  const errorData = response?.data || response;
  return {
    status: response?.status,
    detail:
      errorData?.error ||
      errorData?.detail ||
      errorData?.message,
    data: errorData
  };
};
